import { Controller } from "@hotwired/stimulus"

// Card #3775: a named, collapsible section that remembers open/closed per
// browser via localStorage -- used by the "Analytics" Janela frame section
// on a `kind: :service` project's show page and on /triage. The server
// always renders the section open, so the page is correct before any JS
// runs (Janela's own frames render inline on first response); this
// controller only adjusts what's already in the DOM, it never fetches.
//
// keyValue namespaces the stored state per section (e.g. a project's id, or
// "triage") so two sections on different pages don't share one toggle.
export default class extends Controller {
  static targets = ["content", "chevron"]
  static values = { key: String }

  connect() {
    if (this.readState() === "collapsed") this.applyState(true)
  }

  toggle() {
    const collapsed = !this.contentTarget.classList.contains("hidden")
    this.applyState(collapsed)
    this.saveState(collapsed)
  }

  applyState(collapsed) {
    this.contentTarget.classList.toggle("hidden", collapsed)
    if (this.hasChevronTarget) this.chevronTarget.classList.toggle("-rotate-90", collapsed)
  }

  readState() {
    try {
      return window.localStorage.getItem(this.storageKey)
    } catch {
      return null
    }
  }

  saveState(collapsed) {
    try {
      window.localStorage.setItem(this.storageKey, collapsed ? "collapsed" : "expanded")
    } catch {
      // Private mode / storage disabled -- state just won't persist across visits.
    }
  }

  get storageKey() {
    return `collapsible-section:${this.keyValue}`
  }
}
